window.PositionsAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    self.getPositionsSettingsLevels = function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/positions/settings', 'GET').then(function (res) {
            if (res && res.data && res.data.data && res.data.data.level) {
                var levels = res.data.data.level.split(',');
                var positionsSettings = {
                    'levels': levels,
                    'mode': res.data.data.position_management_mode
                };
                defer.resolve(positionsSettings);
            } else {
                defer.reject([]);
            }
        })
        .catch((err) => {
            defer.reject(err);
        });

        return defer.promise;
    };


    self.getPositionsSettings = function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings/positions', 'GET').then(function (res) {
            if (res && res.data && res.data.data && res.data.data.positions) {
                defer.resolve(res.data.data.positions);
            } else {
                defer.reject(res);
            }
        });

        return defer.promise;
    };

    self.savePositionsSettings = function (brandId, positions) {
        var defer = $q.defer();

        var params = {
            positions: positions
        };

        _protected.request('brands/' + brandId + '/settings/positions', 'PUT', params)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data);
                } else {
                    defer.reject(res);
                }
            });

        return defer.promise;
    };

    self.updatePositionsGroupSettings = function (brandId, positions) {
        var defer = $q.defer();

        var params = {
            position_group: positions
        };
        _protected.request('brands/' + brandId + '/settings/position_groups/' + positions.id, 'PUT', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    defer.resolve(res.data);
                } else {
                    defer.reject(res);
                }
            });
        return defer.promise;
    };

    self.savePositionsGroupSettings = function (brandId, positions) {
        var defer = $q.defer();

        var params = {
            position_group: positions
        };

        _protected.request('brands/' + brandId + '/settings/position_groups', 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    defer.resolve(res.data);
                } else {
                    defer.reject(res);
                }
            });
        return defer.promise;
    };

    self.loadPositionsGroupSettings = function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings/position_groups', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data);
                } else {
                    defer.reject(res);
                }
            });
        return defer.promise;
    };

    self.deletePositionsGroupSettings = function (brandId, position) {
        var defer = $q.defer();
        _protected.request('brands/' + brandId + '/settings/position_groups/' + position.id, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    defer.resolve(res.data);
                } else {
                    defer.reject(res);
                }
            });
        return defer.promise;
    };

    self.loadFlatPositions = function () {
        var defer = $q.defer();

        _protected.request('category_positions', 'GET').then(function (res) {
            var data = [];
            res = res.data;

            for (var i in res.data) {
                for (var j in res.data[i].PositionType.Position) {
                    data.push({
                        id: res.data[i].PositionType.Position[j].id,
                        code: res.data[i].PositionType.Position[j].code,
                        name: res.data[i].PositionType.Position[j].name,
                        status: res.data[i].PositionType.Position[j].status,
                        groupName: res.data[i].PositionType.name,
                        groupCode: res.data[i].PositionType.code,
                        category: {
                            id: res.data[i].PositionType.id,
                            code: res.data[i].PositionType.code,
                            name: res.data[i].PositionType.name
                        }
                    })
                }
            }

            defer.resolve(_.sortBy(data, 'name'));
        });

        return defer.promise;
    };

    self.getBusinessSetupSettings = cacheService.cache(function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/business_setup/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch((err) => {
                defer.reject(err);
            });
        return defer.promise;
    })[0];

    self.getBusinessFinancialUnits = function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/financial_units', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            });
        return defer.promise;
    };


    /**
     * Loads the positions by category
     * @returns {*}
     */
    self.loadPositions = function (includeArchived, brandId) {
        var defer = $q.defer();

        var params = {
            include_archived :includeArchived
        };

        if(brandId){
            params['brand_id'] = brandId;
        }

        _protected.request('category_positions', 'GET', params).then(function (res) {
            _protected.handleResponse(res.data, defer);
        });

        return defer.promise;
    };

    self.getSystemPositions = function () {
        var defer = $q.defer();

        _protected.request('category_positions?get_all_positions=true', 'GET').then(function (res) {
            _protected.handleResponse(res.data, defer);
        });

        return defer.promise;
    };


    /**
     * Loads all the categories for harri positions in the DB
     */
    self.loadCategories = function () {
        var defer = $q.defer();

        if (_protected.getCached('categories')) {
            var data = _protected.getCached('categories');
            defer.resolve(data);
            return defer.promise;
        }

        _protected.request('position_type_lookup', 'GET').then(function (res) {
            _protected.handleResponse(res.data, defer);
        });

        return defer.promise;
    };

    self.CATEGORIES = {};
    self.CATEGORIES.ALL = {code: "ALL", short_name: "All Employees", name: "All Employees"};
    self.CATEGORIES.FOH = {code: "FOH", short_name: "FOH", name: "Front of House"};
    self.CATEGORIES.BOH = {code: "BOH", short_name: "BOH", name: "Back of House"};
    self.CATEGORIES.QS = {code: "QS", short_name: "QS", name: "Quick Service"};
    self.CATEGORIES.MANAGE = {code: "MANAGE", short_name: "Mgmt", name: "Management"};
    self.CATEGORIES["short-term"] = {code: "short-term", short_name: "ST", name: "Short Term/Quick Gig"};
    self.CATEGORIES["Exec-Indus"] = {code: "Exec-Indus", short_name: "Exec", name: "Executive/Industry"};
    self.CATEGORIES["on-demand"] = {code: "on-demand", short_name: "OD", name: "On Demand"};
    self.CATEGORIES["hotel"] = {code: "hotel", short_name: "HTL", name: "Hotel"};
    self.CATEGORIES["retail"] = {code: "retail", short_name: "RET", name: "Retail"};
    self.CATEGORIES["leisure"] = {code: "leisure", short_name: "Leisure", name: "Leisure"};
    self.CATEGORIES["non-variable-labor"] = {code: "non-variable-labor", short_name: "non-variable-labor", name: "Non Variable Labor"};
    self.CATEGORIES["health"] = {code: "health", short_name: "Hlth", name: "Health"};
    self.CATEGORIES["warehouse-distribution"] = {code: "warehouse-distribution", short_name: "WHS", name: "Warehouse/Distribution"};
    self.CATEGORIES["head-office"] = {code: "head-office", short_name: "HO/Supp", name: "Head Office/Support Centre"};
    self.CATEGORIES["Technical"] = {code: "Technical", short_name: "Tech", name: "Technical"};
    self.CATEGORIES["Maintenance"] = {code: "Maintenance", short_name: "MNT", name: "Maintenance"};
    self.CATEGORIES["Horticulture"] = {code: "Horticulture", short_name: "Hortic", name: "Horticulture"};
};


